
import React from 'react';
import ZNetwork from "./znetwork.js";
import ZProps from "./zprops.js";
import ZLog from "./zlog.js";
import { ZOO } from "./zoo.js";
import { APP } from "./App.js";
import AMC from "./AMC.js";
import PleaseStandBy from "./PleaseStandBy.js";
import ZooNothingFoundPage from "./ZooNothingFoundPage.js";
import { ZooSearchResultLineItem } from "./ZooLeaderboardsPage.js";
import ZooErrorFoundPage from "./ZooErrorFoundPage.js";
import AMCConstants from "./AMCConstants.js";

export default class ZooGotAlgorithmPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		ZProps.set("path", "is:trainer");
		ZOO.setTitle("is:trainer");
		APP.setTitle("Got Algorithm?");
		AMC.track(AMCConstants.GOT_ALGORITHM_TRACKING_URI);
		ZNetwork.get("search", "is:trainer", (err, list) => {
			if (err) {
				ZLog.error("Unable to fetch algorithms: " + err);
				this.setState({ items: [], error: err });
			} else {
				this.setState({ items: list.trainers || [], error: null });
			}
		});
	}
	componentWillUnmount() {
		ZOO.setTitle(null);
	}
	render() {
		let { items } = this.state;
		if (!items) {
			return <PleaseStandBy />;
		}
		if (items.length === 0) {
			return <ZooNothingFoundPage />;
		}
		if (this.state.error) {
			return <ZooErrorFoundPage />;
		}
		let items_widgets = [];
		for (let i = 0; i < items.length; ++i) {
			items_widgets.push(<ZooSearchResultLineItem item={items[i]} rank={i + 1} />);
		}
		return (
			<div className="ZooGeneralPage"> 
				<div className="ZooGeneralPageHeader">
					<h1>Got an algorithm?</h1>
					<h1><ul>
						<li>1. Use search (above) to find an algorithm similar to yours</li>
						<li>2. Select it and then select 'Users' to see the list of services using it</li>
						<li>3. Open one of those services in Rockstar, clone it and edit its algorithm, replacing it with yours</li>
					</ul></h1>
					<h1>This new cloned service of yours can be used to train, test and deploy your algorithm</h1>
				</div>
				{items_widgets}
			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/ZooGotAlgorithmPage.js